import type { FC, ReactNode } from "react";

type Props = {
  isEdit: boolean;
  editNode: ReactNode;
  viewNode: ReactNode;
};

export const ModeSwitcher: FC<Props> = ({ isEdit, editNode, viewNode }) => {
  return <>{isEdit ? editNode : viewNode}</>;
};
